// ========================================
// Quick Access Card Component
// ========================================
// Card for quick navigation to app features

import { Link } from 'react-router-dom';

interface QuickAccessCardProps {
  title: string;
  description: string;
  icon: string;
  to: string;
  color: 'primary' | 'secondary' | 'tertiary' | 'accent';
}

const QuickAccessCard = ({ title, description, icon, to, color }: QuickAccessCardProps) => {
  return (
    <Link to={to} className={`quick-access-card glass-card card-${color}`}>
      <div className="card-icon">{icon}</div>
      <h3 className="card-title">{title}</h3>
      <p className="card-description">{description}</p>
    </Link>
  );
};

export default QuickAccessCard;
